module.exports = __webpack_public_path__ + "img/strategy-gantt.39f70736.jpg";